<template>
	<div class="richtext">
		<ScRichText v-if="textField" :field="textField" :tag="tagField" />
	</div>
</template>

<script setup>
import { RichText as ScRichText } from "@sitecore-jss/sitecore-jss-vue";

const props = defineProps({
	fields: { type: Object, required: true },
	text: { type: Object, default: null },
	tag: { type: String, default: "div" },
});

const textField = computed(() => {
	if (props.text && props.text.value) {
		return props.text;
	} else if (props.fields && props.fields.text && props.fields.text.value) {
		return props.fields.text;
	}
	return null;
});

const tagField = computed(() => {
	if (props.fields && props.fields.tag && props.fields.tag.value) {
		return props.fields.tag.value;
	} else if (props.tag) {
		return props.tag;
	}

	return "div";
});
</script>

<style lang="scss">
.richtext {
	padding: 0 var(--spacing-2, 16px);
	color: var(--color-grey-3, #989898);
	font-family: var(--primary-font, sans-serif);
	font-size: var(--text-base, 16px);
	font-weight: 300;
	line-height: 140%;

	a {
		color: inherit;
		text-decoration: underline;
	}

	p,
	li {
		line-height: 140%;
		margin: var(--spacing-2, 16px) 0;
	}

	strong {
		color: var(--color-white, #fff);
	}

	iframe {
		max-width: 100%;
	}

	img {
		max-width: 100%;
	}
}
</style>
